import * as Immutable from "immutable";
import User from "~/records/record.user.jsx";
import UserMap from "~/records/record.user_map.jsx";
import * as actionTypes from "~/store/action_types";

export const user = (state = new User(), action) => {
  switch (action.type) {
    case actionTypes.EDIT_USER_FROM_EVENT_STREAM_SUCCESS:
    case actionTypes.USER_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS:
    case actionTypes.USER_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS:
    case actionTypes.MOVE_USER_TO_ARCHIVE_FROM_EVENT_STREAM_SUCCESS:
    case actionTypes.RESTORE_USER_FROM_ARCHIVE_FROM_EVENT_STREAM_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result: id } = response;
      const { users = {} } = entities;

      if (users[id]) {
        return new User({
          ...state.toObject(),
          ...users[id],
        });
      }

      return state;
    }
    case actionTypes.EDIT_LOGGED_USER_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { users = {} } = entities;

      const { single: id } = result;

      if (users[id]) {
        return new User({
          ...state.toObject(),
          ...users[id],
        });
      }

      return state;
    }
    default:
      return state;
  }
};

const mergeEntities = (state, newUsers) => {
  return state.merge(newUsers.map((u) => new User(u)));
};

const users = (state = new UserMap(), action) => {
  switch (action.type) {
    case actionTypes.ADD_USER_SUCCESS:
    case actionTypes.INVITE_USER_SUCCESS:
    case actionTypes.EDIT_USER_SUCCESS:
    case actionTypes.EDIT_VIRTUAL_USER_SUCCESS:
    case actionTypes.CHANGE_USER_PERMISSIONS_SUCCESS:
    case actionTypes.FETCH_USERS_SUCCESS:
    case actionTypes.FETCH_ALL_USERS_SUCCESS:
    case actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS:
    case actionTypes.ANGULAR_INIT_OTHER:
    case actionTypes.INVITE_USER_TO_PROJECT_SUCCESS:
    case actionTypes.ADD_USER_FROM_EVENT_STREAM_SUCCESS:
    case actionTypes.ARCHIVE_REPLACE_USER_SUCCESS:
    case actionTypes.REMOVE_REPLACE_USER_SUCCESS:
    case actionTypes.CREATE_VIRTUAL_USER_SUCCESS:
    case actionTypes.ACTIVATE_VIRTUAL_USER_SUCCESS:
      if (!action || !action.response || !action.response.entities || !action.response.entities.users) {
        return state;
      }
      return mergeEntities(state, Immutable.fromJS(action.response.entities.users));
    case actionTypes.EDIT_USER_FROM_EVENT_STREAM_SUCCESS:
    case actionTypes.USER_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS:
    case actionTypes.USER_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS:
    case actionTypes.MOVE_USER_TO_ARCHIVE_FROM_EVENT_STREAM_SUCCESS:
    case actionTypes.RESTORE_USER_FROM_ARCHIVE_FROM_EVENT_STREAM_SUCCESS: {
      const { response = {} } = action;
      const { result: id } = response;

      return state.set(`${id}`, user(state.get(`${id}`), action));
    }
    case actionTypes.EDIT_LOGGED_USER_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;

      const { single: id } = result;

      return state.set(`${id}`, user(state.get(`${id}`), action));
    }
    case actionTypes.FETCH_FILES_FILTERS_SUCCESS: {
      const { response = {} } = action;
      const { uploader } = response;
      if (uploader) {
        return mergeEntities(state, Immutable.fromJS(uploader));
      }
      return state;
    }
    default:
      return state;
  }
};

export default users;
